import React, { useEffect, useState } from "react";
import "./index.css";
import ProtocolTable from "./ProtocolTable";
import Disclaimer from "./Disclaimer";

const HypertensionPatientReport = (props) => {
  const [apidata, setAPI] = useState();

  useEffect(() => {
    const report = props.data.Data;

    setAPI(report);
  }, [props]);

  let riskCardColor = "";


  riskCardColor = !apidata
    ? "risk-low-color"
    : apidata["Risk category"] === "High Risk"
    ? "risk-high-color"
    : apidata["Risk category"] === "Moderate Risk" ||
      apidata["Risk category"] === "Medium Risk"
    ? "risk-medium-color"
    : "risk-low-color";


  return (
    <div>
      {apidata && (
        <div className="new-report-container">
          <div className="new-report-card">
            <h2 className="report-card-title">
              AI Calculated Risk Score Based on Your Inputs
            </h2>
            <div className="risk-section">
              <div className="risk-cards">
                <div className="risk-card">
                  <h3 className="risk-card-title">Risk Status</h3>
                  <div className={`${riskCardColor} risk-highlight`}>
                    {apidata["Risk category"]}
                  </div>
                </div>
                <div className="risk-card">
                  <h3 className="risk-card-title">Risk Score</h3>
                  <p className={`risk-value`}>{apidata["Risk Score"]}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="new-report-card">
            <h2 className="report-card-title">AI Recommended Protocol</h2>
            <ProtocolTable data={apidata.CDSS} />
          </div>
          <div className="new-report-card">
            <h2 className="report-card-title">Disclaimer</h2>
            <Disclaimer />
          </div>
        </div>
      )}
    </div>
  );
};

export default HypertensionPatientReport;
